export default "__VITE_ASSET__BWtrGSIN__"